import React, { useState } from 'react';
import { MapPin, ChevronDown, ChevronUp } from 'lucide-react';
import QuestionReportCard from './QuestionReportCard';

const LocationReportGroup = ({ question, questionNumber }) => {
    const [expandedLocations, setExpandedLocations] = useState({});

    const toggleLocation = (locationId) => {
        setExpandedLocations(prev => ({
            ...prev,
            [locationId]: !prev[locationId]
        }));
    };

    const locations = Object.values(question.answersByLocation);

    const aggregateStats = locations.reduce((acc, location) => {
        const { stats } = location;
        acc.totalAnswers += stats.totalAnswers || 0;
        Object.entries(stats.multiChoice || {}).forEach(([k, v]) => {
            acc.multiChoice[k] = (acc.multiChoice[k] || 0) + v;
        });
        Object.entries(stats.starRating || {}).forEach(([k, v]) => {
            acc.starRating[k] = (acc.starRating[k] || 0) + v;
        });
        Object.entries(stats.freeText || {}).forEach(([k, v]) => {
            acc.freeText[k] = (acc.freeText[k] || 0) + v;
        });
        return acc;
    }, { totalAnswers: 0, multiChoice: {}, starRating: {}, freeText: {} });

    const hasMultipleLocations = locations.length > 1;

    // Multiple locations view - group by location
    return (
        <div className="space-y-4">
            <div className="flex items-center gap-3 px-4">
                <div className="flex items-center justify-center w-8 h-8 bg-blue-600 text-white rounded-full text-sm font-bold">
                    {questionNumber}
                </div>
                <h2 className="text-xl font-semibold text-gray-900">
                    {question.questionText}
                </h2>
            </div>

            {hasMultipleLocations && (
                <div className="border border-blue-200 rounded-lg overflow-hidden">
                    <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700">
                        <span className="text-sm font-semibold text-white">Genel İstatistikler (Tüm Lokasyonlar)</span>
                        <span className="ml-auto text-xs text-blue-200">{aggregateStats.totalAnswers} toplam yanıt</span>
                    </div>
                    <div className="p-4 bg-white">
                        <QuestionReportCard
                            question={{
                                ...question,
                                stats: aggregateStats
                            }}
                        />
                    </div>
                </div>
            )}

            <div className="space-y-3">
                {locations.map((location) => (
                    <div key={location.locationId} className="border border-gray-300 rounded-lg overflow-hidden">
                        <button
                            onClick={() => toggleLocation(location.locationId)}
                            className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 transition-colors border-b border-gray-200"
                        >
                            <div className="flex items-center gap-3">
                                <MapPin className="w-5 h-5 text-blue-600" />
                                <div className="text-left">
                                    <p className="font-semibold text-gray-900">{location.locationName}</p>
                                    <p className="text-sm text-gray-600">
                                        {location.stats.totalAnswers} yanıt
                                    </p>
                                </div>
                            </div>
                            {expandedLocations[location.locationId] ? (
                                <ChevronUp className="w-5 h-5 text-gray-600" />
                            ) : (
                                <ChevronDown className="w-5 h-5 text-gray-600" />
                            )}
                        </button>

                        {expandedLocations[location.locationId] && (
                            <div className="p-4 bg-white">
                                <QuestionReportCard
                                    question={{
                                        ...question,
                                        stats: location.stats
                                    }}
                                    location={location}
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LocationReportGroup;
